import moment from 'moment';


export const roundNumber = (value) => {
  const number = Number(value);
  if (Number.isInteger(number)) {
    return number;
  } else {
    return number.toFixed(0);
  }
}

export const dateFormat = (value, format) => {
  return moment(value).format(format);
}